
import { TenantIpRestrictionModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { ipRestrictionsStore } from '@/libs/tenant-ip-restrictions/+state/store';
import TenantIpRestrictionDialog from '@/libs/settings/components/TenantIpRestrictionDialog.vue';

@Component({
    components: {
        TenantIpRestrictionDialog,
    },
})
export default class TenantIpRestrictions extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('common.ip'), value: 'code', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: TenantIpRestrictionDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return ipRestrictionsStore.useGetter(CrudGetter.Pending);
    }

    get ipRestrictions(): TenantIpRestrictionModel[] {
        return [...ipRestrictionsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...ipRestrictionsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        ipRestrictionsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<TenantIpRestrictionModel>({ field: 'ip', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: TenantIpRestrictionModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
